import { FC } from "react";
import OmnichannelAnalyticsTabsDashboard from "../components/OmnichannelAnalyticsTabsDashboard";

const OmnichannelAnalyticsDashboard: FC = () => {
  return <OmnichannelAnalyticsTabsDashboard />;
};

export default OmnichannelAnalyticsDashboard;
